import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import FullPageLoader from '../components/FullPageLoader';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import {
  RouteConfig,
  notFoundRoute,
  privateRoutes,
  publicOnlyRoutes,
  publicRoutes,
} from './RouteConfig';

const Landing = lazy(() => import('../pages/Landing'));

const renderRouteElement = (route: RouteConfig) => (
  <Suspense fallback={<FullPageLoader message="Carregando pagina..." />}>
    <route.element />
  </Suspense>
);

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback={<FullPageLoader message="Carregando..." />}>
            <Landing />
          </Suspense>
        }
      />

      {publicRoutes.map((route) => (
        <Route key={route.path} path={route.path} element={renderRouteElement(route)} />
      ))}

      <Route element={<PublicRoute />}>
        {publicOnlyRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={renderRouteElement(route)} />
        ))}
      </Route>

      <Route element={<PrivateRoute />}>
        {privateRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={renderRouteElement(route)} />
        ))}
      </Route>

      <Route path={notFoundRoute.path} element={renderRouteElement(notFoundRoute)} />
    </Routes>
  );
};

export default AppRoutes;
